import React from "react"
import BlogPosts from '../components/blog-posts'
import WuformButton from '../components/wuform-button'
import LayoutDumpster from "../components/layout-dumpster"
import SuccessBtnDumpsters from "../components/success-btn-dumpsters"

const PROGUIDEPAGEDUMPSTERS = ({ pageContext }) => 
{ 
    const code = pageContext.code;
    const posts = pageContext.posts;
    const env = pageContext.env;      

    const seo = 
    {
        url: 'pro/guide',
        env: env,
        code: code,
        page: 'guides'
    }

    return (
        <LayoutDumpster seo={seo} code={code} env={env} hidden={true} callToAction={true}>
            <div className="blog">
                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="main-title">Success Stories</h1>
                            <BlogPosts posts={posts}/>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar">                                   
                                <div className="block">
                                    <WuformButton env={env} />
                                </div>         
                                <div className="block">                                    
                                    <SuccessBtnDumpsters />
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>           
            </div> 
        </LayoutDumpster>
    )
};

export default PROGUIDEPAGEDUMPSTERS;